import { useState } from "react";
import { AxiosError } from "axios";
import { getAddresses } from "./address-lookup-service";
import { SearchAddress } from "./types";
import { userErrorsMessages, userErrors } from "../auth/user-errors";
import { useAuth } from "../auth/identity-auth0-context";

const searchResultsErrorMessage =
  "An error occurred while fetching the results. Please try again later.";

const useAddressLookup = () => {
  const { hasClientId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [addressOptions, setAddressOptions] = useState<SearchAddress[]>([]);
  const [error, setError] = useState<JSX.Element | string | null>(null);

  const fetchAddresses = async (postcode: string) => {
    if (!hasClientId) {
      setError(userErrorsMessages.clientIdNotFound);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const data = await getAddresses(postcode);
      setAddressOptions(data.results);
    } catch (err) {
      setError(searchResultsErrorMessage);

      if (err instanceof AxiosError && err.response) {
        if (err.response.data === userErrors.clientIdNotFound) {
          setError(userErrorsMessages.clientIdNotFound);
        } else if (err.response.data === userErrors.invalidClientId) {
          setError(userErrorsMessages.invalidClientId);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchAddresses,
    addressOptions,
    error,
    loading,
  };
};

export default useAddressLookup;
